import { render, staticRenderFns } from "./index_bak.vue?vue&type=template&id=6c4561b6&scoped=true&"
import script from "./index_bak.vue?vue&type=script&lang=js&"
export * from "./index_bak.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c4561b6",
  null
  
)

export default component.exports